import { isValidNumber, parse } from 'libphonenumber-js';

import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';

const COUNTRY_CODE = 'GB';

// TODO: move to a new file under src/bl/validation/
export const validateEmailWithDomain = (value) => {
  // noinspection RegExpRedundantEscape
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line max-len
  return emailRegex.test(value);
};

// TODO: move to a new file under src/bl/validation/
export const validatePhone = (value) => {
  if (value === '' || value === undefined) {
    return false;
  }
  // We need to know what country we expect the user to be in, because she probably won't type her country code in
  const newValue = fromAnyToSpacelessString(value);
  const parsedNumber = parse(newValue, COUNTRY_CODE);
  try {
    if (isValidNumber(parsedNumber)) {
      return true;
    }
  } catch (error) {
    if (error instanceof TypeError) {
      return false;
    }
    throw error;
  }
  return false;
};

export const validatePrice = (value) => {
  const regex = /^\d*\.?\d{0,2}$/; // empty, 0, 1 or 2 digits after dot.
  return regex.test(value);
};
